import { render, staticRenderFns } from "./Settings.vue?vue&type=template&id=1b64c3b1&scoped=true&"
import script from "./Settings.vue?vue&type=script&lang=js&"
export * from "./Settings.vue?vue&type=script&lang=js&"
import style0 from "./Settings.vue?vue&type=style&index=0&id=1b64c3b1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b64c3b1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/skysql-ui-client/skysql-ui-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1b64c3b1')) {
      api.createRecord('1b64c3b1', component.options)
    } else {
      api.reload('1b64c3b1', component.options)
    }
    module.hot.accept("./Settings.vue?vue&type=template&id=1b64c3b1&scoped=true&", function () {
      api.rerender('1b64c3b1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/icons/Settings.vue"
export default component.exports